import { createContext } from 'react';
import { IGameDevelopers } from 'types';

export type TGameDevelopersSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TGameDevelopersCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'createDeveloper'
	| 'editDeveloper';
export interface IFilterValues {
	searchString: string;
	sortBy: TGameDevelopersSortBy;
	countOfItems: TGameDevelopersCountOfItems;
	currentPage: number;
}

export interface IGameDevelopersState {
	gameDevelopers: IGameDevelopers;
	searchString: string;
	sortBy: TGameDevelopersSortBy;
	countOfItems: TGameDevelopersCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForEdit: string;
	typeOfModalWindow: TTypeOfModalWindow;
	needRefetchDevelopers: boolean;
}

export const gameDevelopersInitialState: IGameDevelopersState = {
	gameDevelopers: { gameDevelopersCount: 0, gameDevelopers: [] },
	searchString: '',
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForEdit: '',
	typeOfModalWindow: null,
	needRefetchDevelopers: false,
};

export interface IGameDevelopersContext extends IGameDevelopersState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TGameDevelopersSortBy): void;
	setCountOfItems(count: TGameDevelopersCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForEdit(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
	refetchDevelopers(value: boolean): void;
}

export const GameDevelopersContext = createContext<IGameDevelopersContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForEdit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	refetchDevelopers: () => undefined,
	...gameDevelopersInitialState,
});
